<template>
  <div>
    <b-button v-b-modal.modal-send variant="btn btn-primary">Enviar!</b-button>
    <b-modal
      id="modal-send"
      ref="my-modal"
      hide-header
      hide-footer
      hide-header-close
      :no-close-on-backdrop="true"
    >
      <b-button class="close-button" @click="hideModal">X</b-button>
      <div class="row mt-2">
        <div class="col-12">
          <div v-for="(item, i) in action.email.additionalQuestions" :key="i">
            <contact
              v-if="item.type === 'CONTACT'"
              :type="item.displayType"
              :questionText="item.text"
              :choices="item.choices"
              :index="i"
            />
          </div>
        </div>
      </div>
      <b-button
        class="mt-3"
        block
        variant="btn btn-primary"
        @click="showClossingMessageModal"
        >Enviar</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import contact from '@/components/molecules/metrics/contact';
import EventBus from '../../../eventBus';

export default {
  components: {
    contact,
  },

  data: () => ({}),

  computed: {
    ...mapState('actions', ['action']),
  },

  methods: {
    showClossingMessageModal() {
      EventBus.$emit('showClossingMessage', true);
    },

    hideModal() {
      this.$refs['my-modal'].hide();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style>
.close-button {
  float: right;
  background-color: white;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-contact/index.vue